
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { useRouter } from 'next/router';
import '../styles/globals.css';
import SeoAlternates from '../components/SeoAlternates';
import SiteJsonLd from '../components/SiteJsonLd';
function MyApp({ Component, pageProps }) {
    const router = useRouter();
    // Check if the current pathname is the homepage
    const isHomePage = router.pathname === '/';
    // The embeddable widget renders bare (no site chrome) so it can be iframed.
    if (router.pathname === '/widget') {
        return <Component {...pageProps}/>;
    }
    return (<div className={`min-h-screen flex flex-col ${isHomePage ? 'bg-[var(--primary)]' : 'bg-white'}`}>
            <SeoAlternates />
            <SiteJsonLd />
            <Navbar />
            <div className="flex-grow flex">
                <div className={`container my-4 mx-auto flex-grow`}>
                    <Component {...pageProps}/>
                </div>
            </div>
            <Footer />
        </div>);
}
const __Next_Translate__Page__1a1723ec5f3__ = MyApp;

    export default __appWithI18n(__Next_Translate__Page__1a1723ec5f3__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: true,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  